//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server } from "@/services/constants";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import SuccessDialog from "@/components/cards/SuccessDialog";

export default {
  name: "MasterTradeMark",
  components: { SuccessDialog, SuccessDialogPush },

  data() {
    return {
      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 200,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      // Authorization
      userId: 0,
      authorize: [],
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: 0,

      // UI States
      load_bg: false,
      dialogAdd: false,
      dialogAddData: false,
      dialogDelete: false,
      isShowPassword: false,
      fullPage: true,

      // Search and Filter
      search: "",
      search_ct: "",
      s_contact_type: 0,

      // Data
      dataAll: [],
      mDataArray: [],

      // Contact Types
      contact_type: [
        { contact_typenumber: 1, contact_typename: "Client" },
        { contact_typenumber: 2, contact_typename: "Agent" },
        { contact_typenumber: 3, contact_typename: "Associate" },
      ],

      // Form Data
      itemdata: {
        contact_type: 0,
        mapping_cust_id: 0,
        contact_name: "",
        contact_person: "",
        position: "",
        email: "",
        address: "",
        city: "",
        country: "",
        telephone: "",
        fax: "",
        status: "A",
      },
      edititemdata: {
        contact_type: 0,
        mapping_cust_id: 0,
        contact_name: "",
        contact_person: "",
        position: "",
        email: "",
        address: "",
        city: "",
        country: "",
        telephone: "",
        fax: "",
      },

      // Dialog States
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      contactid_del: 0,
      oparation: "",

      // Table Headers
      headers: [
        {
          text: "Contact Type",
          value: "contact_typeShow",
          class: "bg-colorth",
          divider: true,
          width: "8%",
        },
        {
          text: "Contact Name",
          value: "contact_name",
          class: "bg-colorth",
          divider: true,
          width: "10%",
        },
        {
          text: "Contact Person",
          value: "contact_person",
          class: "bg-colorth",
          divider: true,
          width: "13%",
        },
        {
          text: "Address",
          value: "address",
          class: "bg-colorth",
          divider: true,
          width: "13%",
        },
        {
          text: "Telephone",
          value: "telephone",
          class: "bg-colorth",
          divider: true,
        },
        {
          text: "Email",
          value: "email",
          class: "bg-colorth",
          divider: true,
        },
        {
          text: "POA",
          value: "poa",
          class: "bg-colorth",
          divider: true,
          align: "center",
          sortable: false,
        },
        {
          text: "",
          value: "actions",
          class: "bg-colorth",
          divider: true,
          width: "95px",
          sortable: false,
        },
      ],

      customer_name_list: [],
    };
  },

  async mounted() {
    this.$showLoader();
    await api.checkVersion();

    // Check Authorization
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    if (this.authorize_id == null || this.authorize_id == 0) {
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");
    const res_auth = await api.getAuthorize(this.userId, router_path);

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // Load Data
    // await this.loaddataLimit200();
    await this.loaddataPagination();
    await this.loadCustomer();
    this.$hideLoader();
  },

  beforeCreate() {
    this.$store.state.navMenu = true;
  },

  methods: {
    async onOptionsUpdate(options) {
      console.log("Options updated:", JSON.stringify(options));

      this.$showLoader();
      let tmp = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "DESC";
      } else {
        sortDesc = "ASC";
      }

      console.log(`sortDesc:`, sortDesc);

      const result = await api.getAllContactPaginationBySort(
        options.page,
        this.itemsPerPage,
        this.search_ct.trim(),
        this.s_contact_type,
        options.sortBy[0],
        sortDesc
      );
      // console.log(`result.data:`, JSON.stringify(result.data));

      tmp = result.data.data;
      tmp.forEach((item) => {
        if (item.contact_type == 1) {
          item.contact_typeShow = "Client";
        } else if (item.contact_type == 2) {
          item.contact_typeShow = "Agent";
        } else {
          item.contact_typeShow = "Associate";
        }
      });

      this.dataAll2 = tmp;
      this.mDataArray2 = tmp;
      this.totalItems = result.data.pagination.totalItems;
      this.page = result.data.pagination.currentPage;
      this.pageCount = result.data.pagination.totalPages;
      this.$hideLoader();
    },
    async loadDataByPage(pageNumber) {
      this.$showLoader();
      let tmp = [];
      console.log(`pageNumber:`, pageNumber);
      console.log(`itemsPerPage:`, this.itemsPerPage);

      const result = await api.getAllContactPagination(
        pageNumber,
        this.itemsPerPage
      );
      // console.log(`result.data:`, JSON.stringify(result.data));

      tmp = result.data.data;
      tmp.forEach((item) => {
        if (item.contact_type == 1) {
          item.contact_typeShow = "Client";
        } else if (item.contact_type == 2) {
          item.contact_typeShow = "Agent";
        } else {
          item.contact_typeShow = "Associate";
        }
      });

      this.dataAll2 = tmp;
      this.mDataArray2 = tmp;
      this.totalItems = result.data.pagination.totalItems;
      this.page = result.data.pagination.currentPage;
      this.pageCount = result.data.pagination.totalPages;
      this.$hideLoader();
    },

    async loaddataPagination() {
      var tmp = [];
      const result = await api.getAllContactPagination(
        this.page,
        this.itemsPerPage
      );

      tmp = result.data.data;
      tmp.forEach((item) => {
        if (item.contact_type == 1) {
          item.contact_typeShow = "Client";
        } else if (item.contact_type == 2) {
          item.contact_typeShow = "Agent";
        } else {
          item.contact_typeShow = "Associate";
        }
      });

      this.dataAll2 = tmp;
      this.mDataArray2 = tmp;
      this.totalItems = result.data.pagination.totalItems;
      this.page = result.data.pagination.currentPage;
      this.itemsPerPage = result.data.pagination.itemsPerPage;
      this.pageCount = result.data.pagination.totalPages;
    },

    async onSelectMappingCustomerChange(id) {
      this.customer_name_list.filter((item) => {
        if (item.id == id) {
          this.itemdata.contact_name = item.name;
          this.itemdata.contact_person = item.contact_name;
          this.itemdata.address = item.address;
          this.itemdata.city = item.provice;
          this.itemdata.country = item.country;
          return;
        }
      });
    },

    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });
      this.customer_name_list = result.data;
    },

    async loaddataLimit200() {
      var tmp = [];
      const result = await api.getAllContactLimit200();
      tmp = result.data;
      tmp.forEach((item) => {
        if (item.contact_type == 1) {
          item.contact_typeShow = "Client";
        } else if (item.contact_type == 2) {
          item.contact_typeShow = "Agent";
        } else {
          item.contact_typeShow = "Associate";
        }
      });
      this.dataAll = tmp;
      this.mDataArray = tmp;
    },

    async loaddata() {
      this.load_bg = true;
      var tmp = [];
      const result = await api.getAllContact();
      tmp = result.data;
      tmp.forEach((item) => {
        if (item.contact_type == 1) {
          item.contact_typeShow = "Client";
        } else if (item.contact_type == 2) {
          item.contact_typeShow = "Agent";
        } else {
          item.contact_typeShow = "Associate";
        }
      });

      this.dataAll = this.mDataArray.concat(tmp);
      this.mDataArray = this.mDataArray.concat(tmp);
      this.load_bg = false;
    },

    async openadd() {
      this.itemdata = {
        contact_type: 0,
        mapping_cust_id: 0,
        contact_name: "",
        contact_person: "",
        position: "",
        email: "",
        address: "",
        city: "",
        country: "",
        telephone: "",
        fax: "",
        status: "A",
      };
      this.dialogAddData = true;
      this.oparation = "create";
    },

    async closeaddItem() {
      this.dialogAddData = false;
      this.itemdata = {
        contact_type: 0,
        mapping_cust_id: 0,
        contact_name: "",
        contact_person: "",
        position: "",
        email: "",
        address: "",
        city: "",
        country: "",
        telephone: "",
        fax: "",
        status: "A",
      };
      this.oparation = "";
    },

    openPOA(item) {
      window.open("/poa/" + item.contact_id);
    },

    openeditItem(item) {
      this.oparation = "update";
      this.itemdata.contact_type = item.contact_type;
      this.itemdata.mapping_cust_id = item.mapping_cust_id;
      this.itemdata.contact_name = item.contact_name;
      this.itemdata.contact_person = item.contact_person;
      this.itemdata.position = item.position;
      this.itemdata.email = item.email;
      this.itemdata.address = item.address;
      this.itemdata.city = item.city;
      this.itemdata.country = item.country;
      this.itemdata.telephone = item.telephone;
      this.itemdata.fax = item.fax;
      this.dialogAddData = true;
      this.contactid_del = item.contact_id;
    },

    deleteItem(item) {
      this.dialogDelete = true;
      this.contactid_del = item;
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    async deleteItemConfirm() {
      this.$showLoader();
      const update_contact = await api.updateContact(this.contactid_del, {
        status: "D",
      });

      if (update_contact.status == 200 || update_contact.status == 201) {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "ลบข้อมูล",
          "ลบข้อมูลสำเร็จ",
          "text-h5 green--text text-center",
          "/contact-list"
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ลบข้อมูล",
          "ไม่สามารถลบได้",
          "text-h5 red--text text-center"
        );
      }

      this.dialogDelete = false;
      await this.loaddataLimit200();
      this.$hideLoader();
    },

    async saveaddItem() {
      // Validation
      if (!this.itemdata.contact_type) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Contact Type",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (!this.itemdata.contact_name) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Contact Name",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (!this.itemdata.address) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Full Address",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.itemdata.contact_type == 2 && this.itemdata.email == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Email",
          "text-h5 red--text text-center"
        );
        return;
      }

      this.$showLoader();

      if (this.oparation == "create") {
        const create_contact = await api.createContact(this.itemdata);

        if (create_contact.status == 200 || create_contact.status == 201) {
          this.onSearch();
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "บันทึกข้อมูล",
            "บันทึกข้อมูลสำเร็จ",
            "text-h5 green--text text-center",
            "/contact-list"
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "บันทึกข้อมูล",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
        }
      } else {
        this.edititemdata.contact_type = this.itemdata.contact_type;
        this.edititemdata.mapping_cust_id = this.itemdata.mapping_cust_id;
        this.edititemdata.contact_name = this.itemdata.contact_name;
        this.edititemdata.contact_person = this.itemdata.contact_person;
        this.edititemdata.position = this.itemdata.position;
        this.edititemdata.email = this.itemdata.email;
        this.edititemdata.address = this.itemdata.address;
        this.edititemdata.city = this.itemdata.city;
        this.edititemdata.country = this.itemdata.country;
        this.edititemdata.telephone = this.itemdata.telephone;
        this.edititemdata.fax = this.itemdata.fax;

        const update_contact = await api.updateContact(
          this.contactid_del,
          this.edititemdata
        );

        if (update_contact.status == 200 || update_contact.status == 201) {
          this.onSearch();
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "บันทึกข้อมูล",
            "บันทึกข้อมูลสำเร็จ",
            "text-h5 green--text text-center",
            "/contact-list"
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "บันทึกข้อมูล",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
        }
      }

      this.closeaddItem();
      this.$hideLoader();
    },

    async onSearch() {
      if (!this.s_contact_type && this.search_ct == "") {
        await this.loaddataLimit200();
      } else {
        this.mDataArray = [];
        var s_data = {
          search_ct: this.search_ct.trim(),
          contact_type: this.s_contact_type,
        };

        const result = await api.getMasterContactSearch({
          params: s_data,
        });

        this.mDataArray = result.data;
      }
    },

    async onSearchPagination() {
      if (!this.s_contact_type && this.search_ct == "") {
        await this.loaddataPagination();
      } else {
        this.mDataArray2 = [];
        let tmp = [];
        this.page = 1;
        this.$showLoader();
        var s_data = {
          page: 1,
          limit: this.itemsPerPage,
          search_ct: this.search_ct.trim(),
          contact_type: this.s_contact_type,
        };

        const result = await api.getAllContactPaginationByQuery(
          s_data.page,
          s_data.limit,
          s_data.search_ct,
          s_data.contact_type
        );

        tmp = result.data.data;
        tmp.forEach((item) => {
          if (item.contact_type == 1) {
            item.contact_typeShow = "Client";
          } else if (item.contact_type == 2) {
            item.contact_typeShow = "Agent";
          } else {
            item.contact_typeShow = "Associate";
          }
        });

        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;
        this.totalItems = result.data.pagination.totalItems;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.itemsPerPage;
        this.pageCount = result.data.pagination.totalPages;
        this.$hideLoader();
      }
    },

    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
